import { render } from "./TheSubscriptionGenerals.vue?vue&type=template&id=669769b8"
import script from "./TheSubscriptionGenerals.vue?vue&type=script&lang=js"
export * from "./TheSubscriptionGenerals.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__